export default "__VITE_ASSET__CwO35DNM__"